export const GUEST_SESSION_LIMIT_REASON = "too_many_active_guests_from_ip";

const TERMINAL_REJECTION_COMMANDS = new Set(["ACCESS_DENIED", "RATE_LIMITED"]);

export function isTerminalWebsocketRejection(data: any) {
  return TERMINAL_REJECTION_COMMANDS.has(data?.cmd);
}

export function getConnectionBlockedMessageKey(reason: string | null) {
  if (reason === GUEST_SESSION_LIMIT_REASON) {
    return "guestSessionLimitMessage";
  }

  return "connectionTemporarilyLimitedMessage";
}
